import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DeliveryNotesTableEntry } from '@dto/deliveryNotesTableEntry';
import { DeliveryNote } from '@models/deliveryNote';
import { TableColumn } from '@models/tableColumn';
import { TableOptions } from '@models/tableOptions';
import { DeliveryNotesService } from '@services/entity/delivery-notes.service';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import '@angular/localize/init';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionDeliveryNoteDto } from '@dto/transactionDeliveryNoteDto';
import { KwhPipe } from '../../../pipes/kwh.pipe';

@Component({
  selector: 'app-delivery-notes',
  templateUrl: './delivery-notes.component.html',
  styleUrls: ['./delivery-notes.component.scss']
})
export class DeliveryNotesComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'DeliveryNotesComponent';

  @ViewChild('operatorView') operatorView: TemplateRef<any>;
  @ViewChild('customerView') customerView: TemplateRef<any>;
  @ViewChild('userView') userView: TemplateRef<any>;

  public isOperatorView = false;

  public entities: DeliveryNotesTableEntry[];

  public transactions: TransactionDeliveryNoteDto[];
  public selectedDeliveryNote: DeliveryNote;

  public tableColumns: TableColumn[] = [
    {
      columnDescription: $localize`:@@DeliveryNotesColumn1:Name des Lieferscheins`,
      property: 'deliveryNoteNumber'
    }, {
      columnDescription: $localize`:@@DeliveryNotesColumn2:Vorname`,
      property: 'userFirstName'
    }, {
      columnDescription: $localize`:@@DeliveryNotesColumn3:Nachname`,
      property: 'userLastName'
    }, {
      columnDescription: $localize`:@@DeliveryNotesColumn4:kWh`,
      property: 'chargingAmount',
      options: { columnPipe: { pipe: new KwhPipe() } }
    }, {
      columnDescription: $localize`:@@DeliveryNotesColumn5:Lieferzeitraum`,
      property: 'deliveryPeriodString'
    }, {
      columnDescription: $localize`:@@DeliveryNotesColumn6:Versand`,
      property: 'deliveryNoteSendTimestamp',
      options: { columnPipe: { pipe: new DEDatePipe() } }
    },
  ];

  public tableOptions: TableOptions = {
    showNumbering: true,
    hideActions: true,
    rowRouterLink: 'edit/{deliveryNoteId}'
  };

  constructor(
    public deliveryNotesService: DeliveryNotesService,
    public dialog: NgbModal,
    injector: Injector) {
    super(deliveryNotesService, injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
  }

  initializeEntities() {
    if (this.activatedRoute.snapshot.data['isOperatorView']) {
      this.deliveryNotesService.getDeliveryNotesOfCustomer(this.activatedRoute.parent.snapshot.params.key).subscribe(result => {
        this.entities = result;
        super.setupTable();
        this.tableFunctions.sortColumn = 'index';
        this.tableFunctions.sortDirection = 'desc';
      }, error => {});
    } else {
      this.deliveryNotesService.getDeliveryNotes().subscribe(result => {
        this.entities = result;
        super.setupTable();
        this.tableFunctions.sortColumn = 'index';
        this.tableFunctions.sortDirection = 'desc';
      }, error => {});
    }
  }

  matches(entry: DeliveryNotesTableEntry, term: string) {
    var chargingPower = entry.chargingAmount / 1000;

    return entry.deliveryNoteNumber?.toLowerCase().includes(term.toLowerCase()) ||
      entry.userFirstName?.toLowerCase().includes(term.toLowerCase()) ||
      entry.userLastName?.toLowerCase().includes(term.toLowerCase()) ||
      chargingPower.toString().includes(term.toLowerCase()) ||
      entry.deliveryPeriodString?.toLowerCase().includes(term.toLowerCase());
  }

  determineTemplate() {
    if(this.authenticationService.userHasRole('Operator')) {
      return this.operatorView;
    }
    else if (this.authenticationService.userHasRole('Customer') || this.authenticationService.userHasRole('Account')) {
      return this.customerView;
    }
    else if (this.authenticationService.userHasRole('User')) {
      return this.userView;
    }
  }
}
